import { Button, Flex, Modal, Stack, Text } from "@mantine/core";

type Props = {
	opened: boolean;
	onClose: () => void;
	handleCloseAiDocumentSelectionResult: () => void;
};

export const AiDocumentSelectionResultCloseConfirmationDialog = ({
	opened,
	onClose,
	handleCloseAiDocumentSelectionResult,
}: Props) => {
	return (
		<Modal.Root opened={opened} onClose={onClose} radius="md" centered>
			<Modal.Overlay />
			<Modal.Content>
				<Modal.Header>
					<Modal.Title fz="xl">書類選考結果を閉じる</Modal.Title>
					<Modal.CloseButton />
				</Modal.Header>
				<Modal.Body p="lg">
					<Stack gap="lg">
						<Text>
							Lite版では、一度閉じると再度開くことはできません。よろしいですか？
						</Text>
						<Flex gap="md" justify="flex-end">
							<Button variant="outline" color="gray" onClick={onClose}>
								<Text>キャンセル</Text>
							</Button>
							<Button
								color="red"
								onClick={() => {
									onClose();
									handleCloseAiDocumentSelectionResult();
								}}
							>
								<Text>閉じる</Text>
							</Button>
						</Flex>
					</Stack>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	);
};
